import type { RouteObject } from "react-router-dom";
import { useParams } from "react-router-dom";
import { AccountPage } from "@/modules/account/pages/AccountPage";
import { useLocale } from "@seller/app/locale";

function AccountRoute() {
  const locale = useLocale();
  const { storeSlug = "" } = useParams();

  return <AccountPage locale={locale} storeSlug={storeSlug} />;
}

export const accountRoutes: RouteObject[] = [
  {
    path: "account",
    element: <AccountRoute />,
  },
];
